import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * Protected route wrapper.
 *   Session?  NO  → /signin?next=<where you were going>
 *             YES → render
 * The auth store is seeded synchronously from the auth service, so an
 * authenticated user renders on the first frame with no redirect flash.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status !== 'authenticated') {
    const next = `${location.pathname}${location.search}${location.hash}`;
    const query = next && next !== '/' ? `?next=${encodeURIComponent(next)}` : '';
    return <Navigate to={`/signin${query}`} replace />;
  }
  return children;
}
